"use client";
import Link from "next/link";
import { LogoIcon } from "./Icons";
import { useTranslation } from "@/hooks/useLanguage";

export const Footer = () => {
  const { t } = useTranslation();
  return (
    <footer id="footer">
      <hr className="w-11/12 mx-auto" />

      <section className="container py-20 grid grid-cols-2 md:grid-cols-4 xl:grid-cols-6 gap-x-12 gap-y-8">
        {/* Logo + Brand */}
        <div className="col-span-full xl:col-span-2">
          <Link
            rel="noreferrer noopener"
            href="/"
            className="font-bold text-xl flex items-center gap-2"
          >
            <LogoIcon />
            {t("footer.title_1")}
          </Link>
          <p className="mt-2 text-sm opacity-70">{t("footer.description")}</p>
        </div>

        {/* Product Section */}
        <div className="flex flex-col gap-2">
          <h3 className="font-bold text-lg">{t("footer.product.title")}</h3>
          <Link href="#" className="opacity-60 hover:opacity-100">
            {t("common.features")}
          </Link>
          <Link href="#" className="opacity-60 hover:opacity-100">
            {t("common.pricing")}
          </Link>
          <Link href="#" className="opacity-60 hover:opacity-100">
            {t("footer.product.integrations")}
          </Link>
          <Link href="#" className="opacity-60 hover:opacity-100">
            {t("footer.product.demo")}
          </Link>
        </div>

        {/* Solutions Section */}
        <div className="flex flex-col gap-2">
          <h3 className="font-bold text-lg">{t("footer.solutions.title")}</h3>
          <Link href="#" className="opacity-60 hover:opacity-100">
            {t("footer.solutions.hotels")}
          </Link>
          <Link href="#" className="opacity-60 hover:opacity-100">
            {t("footer.solutions.resorts")}
          </Link>
          <Link href="#" className="opacity-60 hover:opacity-100">
            {t("footer.solutions.vacation_rentals")}
          </Link>
          <Link href="#" className="opacity-60 hover:opacity-100">
            {t("footer.solutions.hostels")}
          </Link>
        </div>

        {/* Resources Section */}
        <div className="flex flex-col gap-2">
          <h3 className="font-bold text-lg">{t("footer.resources.title")}</h3>
          <Link href="#" className="opacity-60 hover:opacity-100">
            {t("footer.resources.help_center")}
          </Link>
          <Link href="#" className="opacity-60 hover:opacity-100">
            {t("footer.resources.documentation")}
          </Link>
          <Link href="#" className="opacity-60 hover:opacity-100">
            {t("common.faqs")}
          </Link>
          <Link href="#" className="opacity-60 hover:opacity-100">
            {t("footer.resources.blog")}
          </Link>
        </div>

        {/* Company Section */}
        <div className="flex flex-col gap-2">
          <h3 className="font-bold text-lg">{t("common.company")}</h3>
          <Link href="#" className="opacity-60 hover:opacity-100">
            {t("common.about")}
          </Link>
          <Link href="#" className="opacity-60 hover:opacity-100">
            {t("footer.company.careers")}
          </Link>
          <Link href="#" className="opacity-60 hover:opacity-100">
            {t("common.contact")}
          </Link>
          <Link href="#" className="opacity-60 hover:opacity-100">
            {t("footer.company.privacy")}
          </Link>
        </div>
      </section>

      {/* Bottom Section */}
      <section className="container pb-14 text-center">
        <h3 className="text-sm opacity-70">
          &copy; {new Date().getFullYear()} {t("footer.copyright.text")}
        </h3>
      </section>
    </footer>
  );
};
